import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import { DateTimeFieldLayoutProps } from 'ui-builder';
import { cn } from 'shadcn-ui';

function LegacyDateTimeFieldLayout(props: DateTimeFieldLayoutProps) {
  if (props.displayValue) {
    const showTitle = props.displayValue !== props.value;
    return (
      <span className={props.className} title={showTitle ? props.value : undefined}>
        {props.displayValue}
      </span>
    );
  } else {
    return (
      <span className={props.className}>
        -
      </span>
    )
  }
}

function ShadcnDateTimeFieldLayout(props: DateTimeFieldLayoutProps) {
  if (props.displayValue) {
    const showTitle = props.displayValue !== props.value;
    return (
      <span className={cn('text-sm text-gray-800', props.className)} title={showTitle ? props.value : undefined}>
        {props.displayValue}
      </span>
    );
  } else {
    return (
      <span className={cn('text-sm text-gray-800', props.className)}>
        -
      </span>
    )
  }
}

export default function DateTimeFieldLayout(props: DateTimeFieldLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnDateTimeFieldLayout {...props} />;
  } else {
    return <LegacyDateTimeFieldLayout {...props} />;
  }
}
